<template>
  <Modal name="CHANGE_APPOINTMENT_TYPE_MODAL" :title="$t('appointment.adminActions.changeType.action')">
    <template v-slot:body>
      <div>
        <v-form v-model="valid" ref="appointmentFormChangeType">
          <v-row>
            <v-col>
              <AdminServiceTypeSelect
                v-model="selectedType"
                :rules="rules"
                :label="$t('appointment.adminActions.changeType.selectType')"
                :showOutterLabel="false"
                :multiple="false"
              />
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col class="d-flex justify-end">
              <v-btn
                @click="validate"
                :loading="isChangingType"
                elevation="0"
                color="primary"
                large
                dark
              >
                {{ $t('appointment.adminActions.changeType.action') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/app/Modal'
import { required } from '@/util/errorHandling'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AdminServiceTypeSelect from '@/components/AdminServiceTypeSelect'

export default {
  name: 'appointmentFormChangeType',
  components: {
    Modal,
    AdminServiceTypeSelect
  },
  data() {
    return {
      rules: [
        required,
        (v) => v !== this.previousType || 'Tipo de serviço não pode ser o mesmo'
      ],
      valid: false,
      previousType: null,
      selectedType: null,

      isChangingType: false,
    }
  },
  computed: {
    ...mapGetters(['appointment', 'isLoading']),
  },
  methods: {
    ...mapActions(['changeAppointmentType']),

    validate() {
      if (this.$refs.appointmentFormChangeType.validate()) {
        this.isChangingType = true

        const body = {
          appointment_id: this.appointment.id,
          type: this.selectedType
        }

        this.changeAppointmentType(body)
          .then(() => {
            if (this.$parent?.refreshMap) this.$parent?.refreshMap()
            if (this.$parent?.refreshAppointments) this.$parent?.refreshAppointments()
          })
          .finally(() => this.isChangingType = false)
      }
    },
  },
  mounted() {
    this.previousType = this.appointment.type
  },
}
</script>
